// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__2URcl","title":"style_title__2w7BM"};